(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BT-Sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      new Promise(resolve => setTimeout(resolve, 2200))
        .then(() => {
          const top = document.querySelector('product-info product-form').getBoundingClientRect().bottom + window.scrollY

          window.addEventListener('scroll', () => {
            if (window.scrollY > top) {
              this.classList.add('show')
              document.body.style.paddingBottom = this.clientHeight + 'px'
            } else {
              this.classList.remove('show')
              document.body.style.paddingBottom = 0
            }
          })

          const btnOptions = this.querySelector('.ks-sticky-atc-btn-choose-options')

          btnOptions?.addEventListener('click', (e) => {
            document.querySelector('product-info').scrollIntoView({
              behavior: 'smooth'
            })
          })
        })
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BT-fancy-slider"] && !Shopify.designMode) return;
  try {
    
class KsFancySlideshow extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.myInterval = setInterval(() => {
      this.init()
    }, 100);

    document.addEventListener('shopify:section:load', () => {
      if (event.target.querySelector('.ks-fancy-slideshow')) {
        this.init()
      }
    })
  }

  init () {    
    if (!window.Swiper) return

    const sliderElem = this.querySelector('.swiper')

    const navigation = {
      enabled: sliderElem.dataset.swiperNavigation === 'true',
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next' 
    }
  
    const pagination = {
      enabled: sliderElem.dataset.swiperPagination === 'bullets' || sliderElem.dataset.swiperPagination === 'fraction',
      el: '.swiper-pagination',
      type: sliderElem.dataset.swiperPagination,
      dynamicBullets: false,
      dynamicMainBullets: 2,
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
      }
    }

    const effect = sliderElem.dataset.swiperEffect
  
    const scrollbar = {
      enabled: sliderElem.dataset.swiperPagination === 'scrollbar',
      el: sliderElem.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  
    const speed = Number(sliderElem.dataset.swiperSpeed || 300)
  
    const autoplay = sliderElem.dataset.swiperAutoplay === '0'
      ? undefined
      : { delay: Number(sliderElem.dataset.swiperAutoplay) * 1000 }

    const creativeEffect = {
      prev: { translate: [0, 0, -400],},
      next: { translate: ['100%', 0, 0]},
    }

    console.log(sliderElem.dataset.swiperSpacing)

    const breakpoints = {
      0: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.4 : 1,
        spaceBetween: Math.round(Number(sliderElem.dataset.swiperSpacing) * .75)
      },
      750: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.3 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      },
      990: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.2 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      }
    }

    this.slider = new window.Swiper(sliderElem, {
      navigation,
      pagination,
      scrollbar,
      effect,
      speed,
      autoplay,
      creativeEffect,
      breakpoints,
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      fadeEffect: { crossFade: true },
      mousewheel: { enabled: true, forceToAxis: true },
      on: {
      }
    })

    clearInterval(this.myInterval)
  }
}
customElements.define('ks-fancy-slideshow', KsFancySlideshow)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
